
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MessageCenter from "@/components/We/dialog/dialog.vue";
import { UserModule } from "@/store/modules/user";
import { dateToDay, stampTransDay } from "@/utils/time";

@Component({
    components: {
        MessageCenter,
    },
})
export default class extends Vue {
    @Prop({ default: false }) private value!: boolean;

    private timeDispatch :any = {
        today:false,
        lastDay:false,
        early:false
    }
    private messageCates: any[] = [];
    private messageList: any[] = [];
    private activeItem: string = "0";
    private load: boolean = false;
    private loading: boolean = false;
    private requestParams: any = {
        page: 1,
        total: 0,
        page_size: 10,
    };

    @Watch("value")
    changeStatus() {
        if (this.value) {
            (this as any).$refs.messageCenterRef.open({ type: 2 });
            // this.getOptions();
            this.getList();
        }
        if(!this.value){
            this.timeDispatch = {
                today:false,
                lastDay:false,
                early:false
            }
        }
    }

    get total(){
        return UserModule.notice;
    }

    private close() {
        this.$emit("input", false);
    }

    private handlePage(val: any) {
        if(val.page == 1){
            this.timeDispatch = {
                today:false,
                lastDay:false,
                early:false
            }
        }
        Object.assign(this.requestParams, {
            page_size: val.limit,
            page: val.page,
        });

        this.getList();
    }

    private switchTitle(index: any) {
        if (this.activeItem == index) return;
        this.requestParams.page = 1;
        this.activeItem = index;
        this.messageList = [];
        this.getList();
    }

    private setAllRead(){
        if(this.loading)return;
        this.loading = true;
        UserModule.setMsgRead('').then((res)=>{
            this.loading = false;
            if(res.code == 1000){
                this.$message({
                    type:'success',
                    message:res.msg
                })
            }
        });
    }

    private switchToOthers(status:number,val: string, type: number,type_id:number,item:any) {
        let route = type == 1 ? 'trade-list' : 'offline-order';
        let current = (this as any).$router.history.current;
        if(item?.content?.route){
            route = item.content.route;
        }
        if((route != current.name) || (route == current.name && val != current.query.order_id)){
            (this as any).$router.push({
                name: route,
                query: {
                    order_id: val,
                },
            });
        }
        console.log('tips')
        status == 1 && UserModule.setMsgRead(type_id);
        if(route == current.name){
            (this as any).$bus.$emit(route+'-getNewOrder',{order:{id:val}});
        }
        (this as any).$refs.messageCenterRef.close();
    }

    transTime(time:any){
        let now: any = Number((Date.now() / 1000).toFixed(0));
        let gap = now - time;
        if(gap > 3600){
            return stampTransDay(time)
        }else{
            let min = Math.floor(gap / 60);
            return min+'分前'
        }
    }

    private dealTime(current: any) {
        let today: string = dateToDay(new Date());
        let lastDay: string = stampTransDay(Date.now() / 1000 - 60 * 60 * 24);
        let current_time: string = stampTransDay(current.create_time);
        if (current_time == today) {
            if(!this.timeDispatch.today){
                this.timeDispatch.today = true;
                return '今天'
            }else{
                return ''
            }
        } else if (current_time == lastDay) {
            if(!this.timeDispatch.lastDay){
                this.timeDispatch.lastDay = true;
                return '昨天'
            }else{
                return ''
            }
        } else {
            if(!this.timeDispatch.early){
                this.timeDispatch.early = true;
                return '更早'
            }else{
                return ''
            }
        }
    }

    /**
     * 逻辑处理
     * @param {Array}
     */
    private async getList() {
        this.load = true;

        // let type = this.messageCates[Number(this.activeItem)].value;

        const { code, data, msg } = await (this as any).$http.getNoticeList({
            type:1,
            ...this.requestParams,
        });

        if (code == 1000) {
            let list = data.list;
            list.forEach((element:any) => {
                element.timeDispatch = this.dealTime(element)
            });
            this.messageList = list;
            this.requestParams.total = data.total;
        }

        setTimeout(() => {
            this.load = false;
            (this as any).$refs.messageCenterRef.hideLoad({ code, msg });
        }, 100);
    }

    // private async getOptions() {
    //     const { code, data, msg } = await (
    //         this as any
    //     ).$http.getNoticeOptions();

    //     if (code == 1000) {
    //         this.messageCates = data.list;

    //         if (data.list[0] && data.list[0].value) {
    //             this.getList();
    //         }
    //     } else {
    //         (this as any).$refs.messageCenterRef.hideLoad({ code, msg });
    //     }
    // }

    private async read(type: string, val?: string) {
        let api: string = "";
        let params: any = {};

        if (type == "single") {
            api = "readNotice";
            params.id = val;
        } else if (type == "all") {
            if (this.loading) return;

            api = "readAllNotice";
            params = { type: this.messageCates[Number(this.activeItem)].value };
            this.loading = true;
        }

        const { code } = await (this as any).$http[api](params);

        if (code == 1000) {
            if (type == "single") {
                UserModule.SET_NOTICE();
            } else if (type == "all") {
                let num = Number(
                    this.messageCates[Number(this.activeItem)].cnt
                );
                UserModule.SET_NOTICE(num);
                this.messageCates[Number(this.activeItem)].cnt = 0;

                for (let item of this.messageList) {
                    item.status = 2;
                }
            }
        }

        setTimeout(() => {
            this.loading = false;
        }, 200);
    }
}
